// extracted by mini-css-extract-plugin
export default {"name":"UserAvatar_name__sA114","email":"UserAvatar_email__K4opl","menuItem":"UserAvatar_menuItem__bLBto"};